import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Recaptcha from 'react-google-invisible-recaptcha';
import {
  Button,
  Input,
  DatePicker,
  Select,
  Icon,
  Popover,
  Tooltip,
} from 'antd';
import { FaPlane, FaWater } from 'react-icons/fa';
import { TiArrowBackOutline } from 'react-icons/ti';
// import { MdPlace } from 'react-icons/md';
import { FiArrowDownCircle } from 'react-icons/fi';
import moment from 'moment';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import * as actions from '../../actions';

import {
  SHOW_CUSTOM_PORTS_DROPDOWN,
  G_RECAPTCHA_SITE_KEY,
  LANDING_PAGE_SEARCH_CLICK_URL,
} from '../../envVariables';

import ErrorBoundary from '../../ErrorBoundary';
import Dropdown from './Dropdown';
import CustomDropdown from './CustomDropdown';
import DropdownItems from './DropdownItems';
import { isEmpty } from '../../util/isEmpty';
import { ReCaptchaPrivacyTermsToolTip } from '../common/ReCaptchaPrivacyTermsToolTip';
import { isDevENV } from '../../util/isDevENV';
import { isAppUpdateAvailable } from '../../util/isAppUpdateAvailable';
import {setFormView} from "../../actions";

const API_KEY = process.env.REACT_APP_G_MAP_API_KEY;

export const G_API_URL = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&&v=3.exp&libraries=geometry,drawing,places`;

const { Option } = Select;

// const dateFormat1 = "YYYY/MM/DD";
const dateFormat = 'DD MMM, YYYY';

const shipmentType = {
  sea: [
    { name: 'FCL', desc: 'FULL CONTAINER LOAD' },
    { name: 'LCL', desc: 'LESS CONTAINER LOAD' },
  ],
  air: [{ name: 'AIR', desc: 'AIR DELIVERY' }],
};

/**
 * @component
 * @name Searchbar
 * @category Search Page
 * @subcategory Search bar
 * @description This is the main component for top search bar section.
 * <br> <br>
 * **Example**
 * ```js
 *   <Searchbar />
 * ```
 */
class Searchbar extends Component {
  state = {
    type: 'api-fcl',
    date: '',
    rotate: 180,
    css: 'normal-css',
    origin: '',
    destination: '',
    air: false,
    waterButton: 'danger',
    airButton: '',
    marginTop: -32,
    elementsHeight: '53px',
    headerHeight: '14px',
    // isRecaptchaResolved: false, //make it false, if it's true then go ahead make network request
    updateAvailable: false, //whether a new web app update available, default is false
  };
  componentDidMount = () => {
    const { date } = this.state;
    //if date is already set and valid in state then do not update it
    const isValidDate = moment(date, dateFormat, true).isValid();
    !isValidDate &&
      this.setState({
        date: moment(new Date()).format(dateFormat),
      });
  };



  componentWillMount = async () => {
    this.setState(
        {
          type: this.props.queryParams.type,
          date: this.props.queryParams.date,
        },
        this.changeShipmentButtonColor
    );

    this.props.saveCodeSettings({
      useCustomDropdown: SHOW_CUSTOM_PORTS_DROPDOWN === 'YES',
    });

    // check for whether new web app version is available
    const appUpdateAvailable = await isAppUpdateAvailable();

    this.setState({
      updateAvailable: !!appUpdateAvailable,
    });
  };

  /**
   * @description It changes fcl/lcl/air button color
   * which are present left of origin of shipment input section
   * <br> <br>
   * **changeShipmentButtonColor() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  changeShipmentButtonColor = () => {
    if (this.state.type === 'api-air') {
      this.setState({ airButton: 'danger', waterButton: '' });
    } else {
      this.setState({ airButton: '', waterButton: 'danger' });
    }
  };

  /**
   * @description It is invoked when the swap button
   * which is present between origin and destination input fields is clicked.
   * It swaps the origin and destination ports
   * <br> <br>
   * **onSwapLocation() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  onSwapLocation = () => {
    if (this.props.isFormSubmitSuccess) {
      return; //form is used, don't allow to edit the fields
    }
    this.setState({
      css: this.state.css === 'normal-css' ? 'rotate-css' : 'normal-css',
    });
    this.props.setQueryParams({
      ...this.props.queryParams,
      from: this.props.queryParams.to,
      to: this.props.queryParams.from,
    });
  };


  /**
   * @description It is invoked when the search button is clicked
   * <br> <br>
   * **onSearchBtnClick() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  onSearchBtnClick = () => {
    this.props.setFormView()
    const { initAuth, isFormSubmitSuccess } = this.props;
    const { user} = initAuth;
    this.getJsonNow();

  };

  /**
   * @description It is invoked to get remote rate card json
   * for FCL/LCL/AIR mode of transports
   * <br> <br>
   * **getJsonNow() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  getJsonNow = () => {
    const { type, date } = this.state;
    // check for empty dates
    if (!date) {
      console.log('Select "date" first');
      this.props.updateErrorAndLoading('Select "date" first', undefined);
      return;
    }
    const isLandingPageExist = [this.props.location.pathname].filter((o) => o.includes('/landing-page')).length !== 0;
    this.props.getJSON(
      {
        ...this.props.queryParams,
        type,
        date: date,
      },
      () => {
        // check for landing-page, if it exist then redirect to env. variable url
        if (isLandingPageExist) {
          // window.location.href = LANDING_PAGE_SEARCH_CLICK_URL + this.props.url;
          const href = LANDING_PAGE_SEARCH_CLICK_URL + this.props.url;
          // alert(href);
          Object.assign(document.createElement('a'), {
            target: '_top', //_self, _blank,
            href,
          }).click();
        } else {
          // this.props.history.push(this.props.url); //uncomment this line
          // console.log("search.js url: ", this.props.url);
          if (window.location.hostname.includes('ratesearch.primefreight.com')) {
            this.props.logActivity()
          }
          //set cheaper rate
          this.props.sortByCheaper();
          this.props.resetContainersTypeSliders();
          this.props.resetContainerLCLSliders();
          this.props.resetCarrierAndScheduleDateRange();
        }
      }
    );
  };

  /**
   * @description It is invoked when user selects type of shipment
   * <br> <br>
   * **onSelectChange(value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | string        | type of shipments e.g. `AIR`, `LCL`  |
   * <br> <br>
   * Returns: Type: void
   */
  // never upate redux store queryParams.type on onSelectChange change
  // or type of shipment change
  onSelectChange = (value) => {
    // console.log("onSelectChange: ", value);
    if (this.props.isFormSubmitSuccess) {
      return; //form is used, don't allow to edit the fields
    }
    let type = '';
    if (value === 'AIR') {
      type = 'api-air';
    } else if (value === 'LCL') {
      type = 'api-lcl';
    } else {
      type = 'api-fcl';
    }
    this.setState({ type });
  };

  /**
   * @description It is invoked when user selects date
   * <br> <br>
   * **handleDateChange(value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | object        | Moment date object  |
   * <br> <br>
   * Returns: Type: void
   */
  handleDateChange = (value) => {
    if (this.props.isFormSubmitSuccess) {
      return; //form is used, don't allow to edit the fields
    }
    if (moment(value).format(dateFormat) !== 'Invalid date') {
      this.setState({ date: moment(value).format(dateFormat) });
    }
    // else {
    //   this.setState({ date: moment(new Date()).format(dateFormat) });
    // }
  };

  // /**
  //  * @description It verifies google invisible reCaptcha
  //  * <br> <br>
  //  * **verifyReCaptcha() -> {void}**
  //  * <br><br>
  //  * Returns: Type: void
  //  */

  // verifyReCaptcha = async () => {
  //   try {
  //     if (this.recaptcha && this.recaptcha.execute) {
  //       await this.recaptcha.execute();
  //     }
  //   } catch (error) {
  //     console.log('g reCaptcha error:', error);
  //   }
  // };

  // /**
  //  * @description It is invoked when google invisible reCaptcha is resolved
  //  * <br> <br>
  //  * **onResolved() -> {void}**
  //  * <br><br>
  //  * Returns: Type: void
  //  */

  // onResolved = () => {
  //   const resCode =
  //     this.recaptcha &&
  //     this.recaptcha.getResponse &&
  //     this.recaptcha.getResponse();

  //   // send to redux store to save res code
  //   this.props.setReCaptchaCode(resCode, () => {
  //     this.getJsonNow();
  //   });
  // };

  /**
   * @description It hard refresh the web app, so that it will be updated
   * <br> <br>
   * **refreshCacheAndReload() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  refreshCacheAndReload = () => {
    // only refresh app in prod
    if (isDevENV()) {
      return;
    }
    console.log('Clearing cache and hard reloading...');
    if (caches) {
      // Service worker cache should be cleared with caches.delete()
      caches.keys().then(function (names) {
        for (let name of names) caches.delete(name);
      });
    }
    // delete browser cache and hard reload
    window.location && window.location.reload && window.location.reload(true);
  };

  render() {
    const { type, date, waterButton, airButton, updateAvailable } = this.state;
    const {
      useCustomDropdown,
      searchbarHeight,
      primaryColor,
      secondaryColor,
      isFormSubmitSuccess,
      showReCaptcha,
      initAuth,
      showPortSwitcher,
      searchDaysPast,
      searchDaysFuture,
    } = this.props;

    // console.log("prop api-type: ", type);
    const { user, verification } = initAuth;

    const isUserPresent = user && verification ? true : false;

    // for detecting landing page or search bar page
    const isLandingPageExist =
      [this.props.location.pathname].filter((o) => o.includes('/landing-page'))
        .length !== 0;

    return (
      <ErrorBoundary>
        <div className="search-container test1">
          {/* back/edit button for form modal page button */}
          {this.props.isFormSubmitSuccess && (
            <span className="edit-form-block testR1">
              <Tooltip
                title="Back/Edit Search"
                overlayClassName="my-searchbar-edit-form-tooltip"
              >
                <div
                  style={{ width: '64px', marginRight: '10px' }}
                  className="testPur1"
                >
                  {searchbarHeight === 116 && (
                    <h5
                      style={{
                        color: 'white',
                        height: this.state.headerHeight,
                        fontSize: '10px',
                      }}
                      className="top-title"
                    >
                      &nbsp;
                    </h5>
                  )}

                  <span
                    style={{
                      background: secondaryColor,
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer',
                      borderRadius: '5px',
                      marginTop: '0px',
                      height: '53px',
                    }}
                    onClick={() => {
                      this.props.toggleFormModalVisibility();
                    }}
                  >
                    <TiArrowBackOutline size={20} color="white" />
                  </span>
                </div>
              </Tooltip>
            </span>
          )}

          {/* sea and air button */}
          <div
            className="route-block testR1"
            style={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              height: '100%',
            }}
          >
            {/* fcl/lcl or air extreme left clickable spans  */}
            <div
              className="route-block-route-types testPur1"
              style={{ display: 'flex', flexDirection: 'row', width: '16%' }}
            >
              {/* fcl/lcl button */}
              <div style={{ width: '50%' }} className="testPur1">
                {searchbarHeight === 116 && (
                  <h5
                    style={{
                      color: 'white',
                      height: this.state.headerHeight,
                      fontSize: '10px',
                    }}
                    className="top-title"
                  >
                    &nbsp;
                  </h5>
                )}
                <span
                  style={{
                    background: waterButton !== '' ? secondaryColor : '#ffffff',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: isFormSubmitSuccess ? 'default' : 'pointer',
                    borderRadius: '5px 0px 0px 5px',
                    marginTop: '0px',
                    height: '53px',
                  }}
                  onClick={() => {
                    if (this.props.isFormSubmitSuccess) {
                      return; //form is used, don't allow to edit the fields
                    }
                    this.setState({ waterButton: 'danger', airButton: '' });
                    this.setState({ type: 'api-fcl' });
                  }}
                >
                  <FaWater
                    size={20}
                    color={waterButton !== '' ? 'white' : 'black'}
                  />
                </span>
              </div>
              {/* air button */}
              <div style={{ width: '50%' }}>
                {searchbarHeight === 116 && (
                  <h5
                    style={{
                      color: 'white',
                      height: this.state.headerHeight,
                      fontSize: '10px',
                    }}
                    className="top-title"
                  >
                    &nbsp;
                  </h5>
                )}
                <span
                  style={{
                    background: airButton !== '' ? secondaryColor : '#ffffff',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: isFormSubmitSuccess ? 'default' : 'pointer',
                    borderRadius: '0px',
                    marginTop: '0px',
                    height: '53px',
                  }}
                  onClick={() => {
                    if (this.props.isFormSubmitSuccess) {
                      return; //form is used, don't allow to edit the fields
                    }
                    this.setState({
                      air: !this.state.air,
                      waterButton: '',
                      airButton: 'danger',
                    });
                    this.setState({ type: 'api-air' });
                  }}
                >
                  <FaPlane
                    size={20}
                    color={airButton !== '' ? 'white' : 'black'}
                  />
                </span>
              </div>
            </div>

            {/* origin & destination input */}
            <div
              className="route-block-inputs testBla1"
              style={{ width: '54%' }}
            >
              <div style={{ width: '50%' }}>
                {searchbarHeight === 116 ? (
                  <h5
                    style={{
                      color: 'white',
                      height: this.state.headerHeight,
                      fontSize: '10px',
                    }}
                    className="top-title testPur1"
                  >
                    ORIGIN OF SHIPMENT
                  </h5>
                ) : null}

                {useCustomDropdown ? (
                  <CustomDropdown
                    name="origin"
                    placeholder="ORIGIN OF SHIPMENT"
                  />
                ) : (
                  <Dropdown name="origin" placeholder="ORIGIN OF SHIPMENT" />
                )}
              </div>

              {/* swap button and destination  */}

              {/* destination input */}
              <div style={{ width: '50%' }}>
                {searchbarHeight === 116 ? (
                  <h5
                    style={{
                      color: 'white',
                      height: this.state.headerHeight,
                      fontSize: '10px',
                    }}
                    className="top-title testPur1"
                  >
                    DESTINATION OF SHIPMENT
                  </h5>
                ) : null}

                <div className="swap-container">
                  {/* swap button */}
                  {showPortSwitcher && (
                    <Button
                      type="default"
                      size="small"
                      className={`${this.state.css} swap-button`}
                      shape="circle"
                      onClick={this.onSwapLocation}
                      style={{
                        color: this.props.primaryColor,
                        display: isFormSubmitSuccess && 'none',
                      }}
                    >
                      <Icon type="swap" />
                    </Button>
                  )}

                  {useCustomDropdown ? (
                    <CustomDropdown
                      name="destination"
                      placeholder="DESTINATION OF SHIPMENT"
                    />
                  ) : (
                    <Dropdown
                      name="destination"
                      placeholder="DESTINATION OF SHIPMENT"
                    />
                  )}
                </div>
              </div>
            </div>

            {/* date and dropdown  */}
            <div
              className="route-block-date-dropdown my-calendar-21a3741"
              style={{ width: '30%' }}
            >
              <div style={{ width: '50%' }}>
                {searchbarHeight === 116 ? (
                  <h5
                    style={{
                      color: 'white',
                      height: this.state.headerHeight,
                      fontSize: '10px',
                    }}
                    className="top-title"
                  >
                    READY TO LOAD
                  </h5>
                ) : null}

                {/*for date*/}
                <DatePicker
                  defaultValue={moment(date ? date : new Date(), dateFormat)}
                  defaultPickerValue={moment(
                    date ? date : new Date(),
                    dateFormat
                  )}
                  format={dateFormat}
                  onChange={this.handleDateChange}
                  allowClear={false}
                  // disabled = {isFormSubmitSuccess}
                  suffixIcon
                  style={{
                    width: '100%',
                    borderLeft: `1px solid ${primaryColor}`,
                    borderRight: `1px solid ${primaryColor}`,
                  }}
                  inputReadOnly={isFormSubmitSuccess}
                  className={
                    isFormSubmitSuccess && 'datepicker-make-cursor-default'
                  }
                  popupStyle={{ display: isFormSubmitSuccess && 'none' }}

                  showToday={!isLandingPageExist} //don't show it on landing page
                  disabledDate={(current) => {
                    // getting today dates
                    let object_date=new Date()
                    let today_date= object_date
                    //getting last year date
                    let last_year=new Date()
                    let last_year_date=new Date(last_year.setFullYear(last_year.getFullYear() -1 ))
                    // getting two months from now
                    let two_months=new Date()
                    let two_months_from_now=new Date(two_months.setFullYear(two_months.getFullYear(),two_months.getMonth()+2))

                    let past_days=today_date.getTime() - last_year_date.getTime()
                    let past_days_diff=Math.ceil(past_days / (1000 * 60 * 60 * 24))


                    let future_date=two_months_from_now.getTime()- today_date.getTime()
                    let future_days_diff=Math.ceil(future_date/(1000 * 60 * 60 * 24))

                    const currDate =
                      current && (current < moment().subtract(past_days_diff, 'day') || current > moment().add(future_days_diff, 'day'));
                    return currDate;
                  }}
                  dropdownClassName={
                    isLandingPageExist ? 'datepicker-small-dropdown' : null
                  }
                />
              </div>
              {/* fcl, lcl or air dropdown */}
              {/* prettier-ignore */}
              <div style={{width: "50%"}} className={`my-select-21a3741 ${isFormSubmitSuccess && "select-make-cursor-default"}`}>
            {searchbarHeight === 116 ?<h5 style={{
              color: "white", height: this.state.headerHeight,
              fontSize: "10px" }}
                  className="top-title"
              >TYPE OF SHIPMENT</h5>  : null}

            {
              type === "api-air" ?
                <Select
                disabled={isFormSubmitSuccess}
                 className="container-dropdown" onChange={this.onSelectChange}
                  defaultValue={shipmentType.air[0].name} key={shipmentType.air[0].name}>
                  <Option value={shipmentType.air[0].name}>
                    <DropdownItems data={shipmentType.air[0]} />
                  </Option>
                </Select>
                :
                <Select
                disabled={isFormSubmitSuccess}
                 className="container-dropdown" onChange={this.onSelectChange}
                  defaultValue={type === "api-fcl" ? shipmentType.sea[0].name : shipmentType.sea[1].name}
                   key={type === "api-fcl" ? shipmentType.sea[0].name : shipmentType.sea[1].name}>
                  <Option value={shipmentType.sea[0].name}>
                    <DropdownItems data={shipmentType.sea[0]} />
                  </Option>
                  <Option value={shipmentType.sea[1].name}>
                    <DropdownItems data={shipmentType.sea[1]} />
                  </Option>
                </Select>
            }
           </div>
            </div>
          </div>

          {/* seacrh button */}
          <div className="route-block-btn my-btn-danger-21a3741">
            {searchbarHeight === 116 && (
              <h5
                style={{
                  color: 'white',
                  height: this.state.headerHeight,
                  fontSize: '10px',
                }}
                className="top-title"
              >
                &nbsp;
              </h5>
            )}
            {/*Search button for search bar*/}
            <Button
              type="danger"
              onClick={() => {
                if (isFormSubmitSuccess) {
                  return;
                }
                this.onSearchBtnClick();
              }}
              style={{
                height: this.state.elementsHeight,
                width: '100%',
                borderRadius: '5px',
                borderBottom: '2px solid rgba(128,128,128,0.9)',
                fontSize: '18px',
                padding: '0px 45px',
                marginLeft: '5px',
                background: this.props.secondaryColor,
                color: isFormSubmitSuccess && '#bbc',
                cursor: isFormSubmitSuccess && 'default',
                display: isFormSubmitSuccess && 'none',
              }}
              className="search-btn red-color"
              // disabled={isFormSubmitSuccess ? true: false}
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-around',
                  fontSize: window.innerWidth < 430 && '12px',
                }}
                className="testR1"
              >
                <span style={{ marginRight: '4px' }}>SEARCH</span>
                <Icon
                  component={() => (
                    <img
                      height={window.innerWidth < 430 ? '26px' : '36px'}
                      src={require('../../assets/light-arrow.png')}
                      alt="prime-freight-logo"
                    />
                  )}
                />
              </span>
            </Button>
          </div>
          {/* Google reCaptcha if user isnot present and showForm = false */}
          {!isFormSubmitSuccess && !isUserPresent && !showReCaptcha && (
            <div
              style={{
                marginLeft: '10px',
                marginBottom: '-12px',
              }}
            >
              <ReCaptchaPrivacyTermsToolTip />
            </div>
          )}
          {/* {!isFormSubmitSuccess && !isUserPresent && (
            <Recaptcha
              ref={(ref) => (this.recaptcha = ref)}
              sitekey={G_RECAPTCHA_SITE_KEY}
              onResolved={this.onResolved}
              style={{
                visibility: !showReCaptcha && 'hidden',
                width: '0px',
                height: '0px',
              }}
            />
          )} */}
          {/* Show update icon if PWA update available */}
          {updateAvailable && (
            <Tooltip title="Click to Update the App">
              <div
                style={{
                  fontSize: '18px',
                  color: 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontWeight: 'bolder',

                  marginLeft: '10px',
                  marginBottom: '-12px',
                }}
                onClick={this.refreshCacheAndReload}
              >
                <FiArrowDownCircle />
              </div>
            </Tooltip>
          )}
        </div>
      </ErrorBoundary>
    );
  }
}

Searchbar.propTypes = {
  /**
   * Sea FCL rate json
   */
  seaFCLJSON: PropTypes.object,
  /**
   * Sea LCL rate json
   */
  seaLCLJSON: PropTypes.object,
  /**
   * AIR rate json
   */
  airJSON: PropTypes.object,

  /**
   * query params
   */
  queryParams: PropTypes.object,

  /**
   * url (it has relevant params) so that it can be used in browser address field
   */
  url: PropTypes.string,

  /**
   * height of top [search bar]{@link Searchbar} section in px
   */
  searchbarHeight: PropTypes.number,

  /**
   * whether to use custom ports dropdown not google map
   */
  useCustomDropdown: PropTypes.bool,

  /**
   * primary color of web app
   */
  primaryColor: PropTypes.string,
  /**
   * secondary color of web app
   */
  secondaryColor: PropTypes.string,

  /**
   * whether to show map beside view-details section
   */
  showOpenMap: PropTypes.bool,
  /**
   * Whether Form is successfully submitted for first time.
   */
  isFormSubmitSuccess: PropTypes.bool,
  /**
   * initial authentication info
   */
  initAuth: PropTypes.object,

  /**
   * Whether to make google invisible recaptcha visible
   */
  showReCaptcha: PropTypes.bool,
  /**
   * Whether to show port switcher button between origin shipment and destination shipment input field on search page.
   */
  showPortSwitcher: PropTypes.bool,
  /**
   * DatePicker past dates limit on search page
   */
  searchDaysPast: PropTypes.number,
  /**
   * DatePicker future dates limit on search page
   */
  searchDaysFuture: PropTypes.number,
};

const mapStateToProps = ({ route, code_config, form }) => {
  return {
    fclJSON: route.seaFCLJSON,
    lclJSON: route.seaLCLJSON,
    airJSON: route.airJSON,

    queryParams: route.queryParams,
    url: route.url,
    searchbarHeight: code_config.searchbarHeight,

    useCustomDropdown: code_config.useCustomDropdown,
    primaryColor: code_config.primaryColor,
    secondaryColor: code_config.secondaryColor,

    showOpenMap: code_config.showOpenMap,
    isFormSubmitSuccess: form.isFormSubmitSuccess,
    initAuth: code_config.initAuth,

    showReCaptcha: code_config.showReCaptcha,
    showPortSwitcher: code_config.showPortSwitcher,
    searchDaysPast: code_config.searchDaysPast,
    searchDaysFuture: code_config.searchDaysFuture,
  };
};

export default withRouter(connect(mapStateToProps, actions)(Searchbar));
